/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module list
 */

import List from './list';
import ListEditing from './listediting';
import ListUI from './listui';
import ListStyle from './liststyle';
import ListStyleEditing from './liststyleediting';
import ListStyleUI from './liststyleui';
import TodoList from './todolist';
import TodoListEditing from './todolistediting';
import TodoListUI from './todolistui';

export default {
	List,
	ListEditing,
	ListUI,
	ListStyle,
	ListStyleEditing,
	ListStyleUI,
	TodoList,
	TodoListEditing,
	TodoListUI
};
